//React
import React from 'react';
import {
  Link
} from "react-router-dom";
//Redux
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
//Action
import * as uiAction from '../action/uiAction';
import * as helpAction from '../action/helpAction';
//Add
import { imageResize, imageRotate } from '../func/imageResizeRotate';
//Material-ui
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import IconButton from '@material-ui/core/IconButton';
import Fab from '@material-ui/core/Fab';
//Part
import PartDropZone from './PartDropZone';
import PartChargeIcon from './PartChargeIcon';
import PartImageUploadHelp from './PartImageUploadHelp';
//Icon
import CloseIcon from '@material-ui/icons/Close';
import ClearIcon from '@material-ui/icons/Clear';
import AddAPhotoIcon from '@material-ui/icons/AddAPhoto';
import RotateRightIcon from '@material-ui/icons/RotateRight';
import RotateLeftIcon from '@material-ui/icons/RotateLeft';
import CropIcon from '@material-ui/icons/Crop';
//Dialog
import DialogImageCrop from './DialogImageCrop';

class Comp extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      originImage: null,
      dialogImageCropVisible: false,
  	}
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.originImage !== this.state.originImage && this.state.originImage) {
      this._imageLoad(this.state.originImage);
    }
  }

  async _imageLoad(file) {
    await imageResize(file, 1200)
    .then((res) => {
      this.props.setPhotoMailImageBase64(res.uri);
    })
    .catch((err) => {
      this.props.setPhotoMailImageBase64(null);
      this.props.snackOpen('error', err.comment , 5000)
    })
  }

  async _imageRotate(rotate) {
    let file = this.props.photoMailImageBase64;
    await imageRotate(file, rotate).then((res) => {
      this.props.setPhotoMailImageBase64(res.uri);
    })
  }

  render() {
    let contents;
    if (this.props.checkBool === true) {
      if (this.props.checkType === 'approach') {
        contents = (
          <div>
            <h3 align='center'>
              無料サービスでは送れません
            </h3>
            <div align='center' style={{paddingTop:'15px'}}>
              <PartChargeIcon/>
            </div>
          </div>
        )
      }
      else {
        contents = (
          <div>
            <PartDropZone
              handleDrop={ (v) => this.setState({originImage:v}) }
              style={{position:'relative'}}
            >

              {
                (this.props.photoMailImageBase64) ? (
                  <div>
                    <label htmlFor="photo_file" style={{cursor:"pointer"}}>
                      <div style={{textAlign:'center', margin:'5px', position:'relative', minHeight:'50px'}}>
                        <div align='center' style={{padding:'5px', position:'relative'}}>
                          <img style={{ maxWidth:'160px', maxHeight:'160px' }} src={this.props.photoMailImageBase64} id='thumb' alt='' />
                        </div>
                        <IconButton
                          style={{position:'absolute', right:'0px', top:'0px'}}
                          onClick={ () => this.props.setPhotoMailImageBase64(null) }
                        >
                          <ClearIcon/>
                        </IconButton>
                      </div>
                    </label>
                    <div align='center'>
                      <Fab
                        color='inherit'
                        size='small'
                        onClick={ () => this._imageRotate('l')}
                      >
                        <RotateLeftIcon/>
                      </Fab>
                      &nbsp;
                      <Fab
                        color='inherit'
                        size='small'
                        onClick={ () => this._imageRotate('r')}
                      >
                        <RotateRightIcon/>
                      </Fab>
                      &nbsp;
                      <Fab
                        color='inherit'
                        size='small'
                        onClick={ () => this.setState({dialogImageCropVisible: true}) }
                      >
                        <CropIcon/>
                      </Fab>
                    </div>

                    <DialogImageCrop
                      originImage={this.state.originImage}
                      open={this.state.dialogImageCropVisible}
                      close={ () => this.setState({dialogImageCropVisible: false}) }
                      onSubmit={ (img) => this.props.setPhotoMailImageBase64(img) }
                    />

                    <div align='center' style={{padding:'10px'}}>
                      {
                        (this.props.checkType === 'free') ? (
                          <Button
                            variant="contained"
                            color="primary"
                            style={{minWidth:'160px'}}
                            onClick={ () => this.props.submit('photo') }
                          >
                            <span style={{fontSize:'1.2em'}}>送信する</span>
                          </Button>
                        ) : (
                          <div>
                            <Button
                              variant="contained"
                              color="primary"
                              style={{minWidth:'160px'}}
                              onClick={ () => this.props.submit('photo-pending') }
                            >
                              <div>
                                <div>
                                  ガイドラインのチェックをし<br/>
                                  12時間以内に送信されます
                                </div>
                                <div style={{fontSize:'1.4em'}}>アプローチメールを送信する</div>
                              </div>
                            </Button>
                          </div>
                        )
                      }
                    </div>
                  </div>
                ): (
                  <div>
                    <div align='center' style={{padding:'5px'}}>
                      <label htmlFor="photo_file" style={{display:'block'}}>
                        <IconButton component="span">
                          <AddAPhotoIcon style={{fontSize:'4em'}}/>
                        </IconButton>
                      </label>

                      <label htmlFor="photo_file" style={{cursor:"pointer", display:'block'}}>
                        <Button variant="contained" color='primary' component="span">
                          <div>
                            <span style={{fontSize:'1.2em'}}>ファイルを選択する</span>

                          </div>
                        </Button>
                      </label>
                    </div>
                  </div>
                )
              }
              <input
                type='file'
                id='photo_file'
                accept='image/*'
                onChange={ (e) => {
                  this.setState({originImage:e.target.files[0]});
                  e.target.value = null;
                }}
                style={{opacity:'0'}}
              />
            </PartDropZone>
            <div style={{padding:'5px'}} align='right'>
              <PartImageUploadHelp />
            </div>


          </div>
        )
      }
    }
    else {
      if (this.props.checkType === 'noCharge') {
        contents = (
          <div>
            <div align='center' style={{padding:'5px'}}>
              無料サービスでは送れません
            </div>
            <div align='center'>
              <PartChargeIcon/>
            </div>
          </div>
        )
      }
      else if (this.props.checkType === 'noProof') {
        contents = (
          <div>
            {
              (this.props.my.profile.userdata_sex === 'men') ? (
                <div align='center' style={{padding:'5px'}}>
                  アプローチメールを送信するには<br />
                  本人証明が必要です
                </div>
              ) : (
                <div align='center' style={{padding:'5px'}}>
                  メールを送信するには<br />
                  本人証明が必要です
                </div>
              )
            }

            <div align='center' style={{padding:'5px'}}>
              <Link to="/my/proof/person">
                <Button
                  variant="contained"
                  color='primary'
                  style={{minWidth:'200px'}}
                >
                  <span>本人証明を申請する</span>
                </Button>
              </Link>
            </div>
          </div>
        )
      }
      else {
        contents = (
          <div>
            {this.props.checkComment}
          </div>
        )
      }
    }


    return (
      <Dialog
        open={this.props.open}
        maxWidth='xs'
      >
        <div
          style={{
            display:'flex',
            flexDirection:'row',
            alignItems:'center',
            justifyContent:'space-between',
          }}
        >
          <div style={{fontSize:'1.1em',fontWeight:'bold',margin:'15px'}}>
            写真を送信
          </div>
          <IconButton
            onClick={ () => {
              this.props.setPhotoMailImageBase64(null);
              this.props.close();
            }}
          >
            <CloseIcon/>
          </IconButton>
        </div>
        <div style={{padding:'0px 10px', fontSize:'0.9em',color:'#666'}}>
          写真をお相手にだけに送信できます。<br/>
          (お相手以外に写真は公開されません)<br/>
          <span
            className='link'
            onClick={ () => this.props.helpOpen('id',403) }
          >
            <u>送信後でもメールを取り消すと</u>
          </span>
          、受信側の写真も削除できる安心システム。
        </div>

        <div style={{padding:'10px'}}>

          { contents }
        </div>

      </Dialog>
    )
  }
}


const mapStateToProps = (state) => {
	return {
		my: state.my,
	}
};

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({
    ...uiAction,
    ...helpAction,
	}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Comp);
